const ACTION_BAR_SELECTOR = '[data-task-selection-entry-id]';
const ACTION_BAR_BOTTOM_INSET = 12;

const findTaskSelectionActionBar = (entryId: string): HTMLElement | null => {
  if (typeof document === 'undefined') return null;

  return Array.from(document.querySelectorAll<HTMLElement>(ACTION_BAR_SELECTOR))
    .find((element) => element.dataset.taskSelectionEntryId === entryId) ?? null;
};

const getTargetScrollTop = (panel: HTMLElement, actionBar: HTMLElement): number | null => {
  const visibleBottom = panel.getBoundingClientRect().bottom - ACTION_BAR_BOTTOM_INSET;
  const hiddenHeight = actionBar.getBoundingClientRect().bottom - visibleBottom;

  if (hiddenHeight <= 0) return null;

  const maximumScrollTop = Math.max(0, panel.scrollHeight - panel.clientHeight);

  return Math.min(maximumScrollTop, panel.scrollTop + hiddenHeight);
};

export const revealTaskSelectionAction = (entryId: string): void => {
  const actionBar = findTaskSelectionActionBar(entryId);
  const panel = actionBar?.closest<HTMLElement>('.ai-overview-panel');

  if (!actionBar || !panel) return;
  const targetScrollTop = getTargetScrollTop(panel, actionBar);

  if (targetScrollTop === null) return;

  panel.scrollTop = targetScrollTop;
};

export const scheduleTaskSelectionActionReveal = (entryId: string): void => {
  if (typeof globalThis.requestAnimationFrame !== 'function') {
    revealTaskSelectionAction(entryId);

    return;
  }

  globalThis.requestAnimationFrame(() => {
    globalThis.requestAnimationFrame(() => revealTaskSelectionAction(entryId));
  });
};
